// Single source of truth for "which public program did this visitor last see".
// Persisted to localStorage with a cookie mirror — iOS Safari/PWA edge cases
// (private mode, content blockers, separate storage containers) can drop
// either one, but very rarely both.
//
// The inline pre-mount guard in index.html duplicates the *read* logic on
// purpose: it must run synchronously before any bundle loads. Keep the
// shape (UUID-like id, key name "lastProgramId", cookie name "lastProgramId")
// in sync if you change anything here.

const STORAGE_KEY = 'lastProgramId';
const COOKIE_MAX_AGE = 60 * 60 * 24 * 365; // 1 year
const ID_PATTERN = /^[a-z0-9-]{8,}$/i;

export function rememberProgram(id: string): void {
    if (!ID_PATTERN.test(id)) return;
    try { localStorage.setItem(STORAGE_KEY, id); } catch {}
    try {
        document.cookie = `${STORAGE_KEY}=${encodeURIComponent(id)}; path=/; max-age=${COOKIE_MAX_AGE}; SameSite=Lax`;
    } catch {}
}

export function recallProgram(): string | null {
    try {
        const fromStorage = localStorage.getItem(STORAGE_KEY);
        if (fromStorage && ID_PATTERN.test(fromStorage)) return fromStorage;
    } catch {}
    try {
        const match = document.cookie.match(/(?:^|; )lastProgramId=([^;]+)/);
        if (match) {
            const fromCookie = decodeURIComponent(match[1]);
            if (ID_PATTERN.test(fromCookie)) return fromCookie;
        }
    } catch {}
    return null;
}
